import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './index.css'

// import global_pl from '../src/translations/pl/global.json'

import i18next from 'i18next';
import Homepage from './homepage/Homepage'
import { I18nextProvider } from 'react-i18next';
import Backend from 'i18next-http-backend';
import { Analytics } from "@vercel/analytics/react";
// Initialize i18next
i18next
  .use(Backend)
  .init({
    interpolation: { escapeValue: false },
    lng: "pl",
    fallbackLng: "en",
    backend: {
      loadPath: '/translations/{{lng}}/global.json',
    },
  });


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Analytics />
    <I18nextProvider i18n={i18next}>
      <Router>
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Router>
    </I18nextProvider>
  </React.StrictMode>
);
